import { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const Pencil: React.FC<SvgProps> = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      // eslint-disable-next-line max-len
      d="M3.52871 10.4127L10.4127 3.52868C10.6727 3.26868 11.0947 3.26868 11.3547 3.52868L12.472 4.64601C12.732 4.90601 12.732 5.32801 12.472 5.58801L5.58737 12.4713C5.46271 12.5967 5.29337 12.6667 5.11671 12.6667H3.33337V10.8833C3.33337 10.7067 3.40337 10.5373 3.52871 10.4127Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.16663 4.77335L11.2266 6.83335"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
